var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.info,
          expression: "info",
        },
      ],
      ref: "info",
      staticClass: "form-control",
      attrs: {
        rows: "2",
        type: "text",
        maxlength: "80",
        disabled: !_vm.canEdit,
      },
      domProps: { value: _vm.info },
      on: {
        change: _vm.update,
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.info = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "form-control-label" }, [
      _c("h4", [
        _vm._v(" Campaign Info "),
        _c("span", [_vm._v("(maximum 80 char, force new line with <br />)")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }